import { EAccuracyType } from "./eaccuracy-type";
import { IBarcodeReaderSettings } from "./ibarcode-reader-settings";

export class BarecodeReaderSettings implements IBarcodeReaderSettings {
	//#region PROPERTIES

	/** @implements */
	public accuracy: EAccuracyType;

	//#endregion

	//#region METHODS

	constructor(poData?: IBarcodeReaderSettings) {
		this.accuracy = poData?.accuracy ?? EAccuracyType.crosshair;
	}

	/** Retourne `true` si l'instance en paramètre est égale à l'instance courante, `false` sinon.
	 * @param poValue Instance à comparer.
	 */
	public equals(poValue?: IBarcodeReaderSettings): boolean {
		return this === poValue || this.accuracy === poValue?.accuracy;
	}

	//#endregion METHODS
}
